"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabContentNation;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TabContentNationModule = _interopRequireDefault(require("./TabContentNation.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TabContentNation(_ref) {
  var nation = _ref.nation,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabContentNationModule.default.content, className),
    style: style
  }, JSON.stringify(nation));
}